import axios from 'axios';

function postSurveyData(data, setResults) {
  axios.post('/api/neighbourhood/recommendation', {
    data: data
  })
  .then(res => {

    let results = res.data.results[0];
    setResults(results);
  })
  .catch(err => {console.log(err);});
  // console.log(data);
}

export function postSubscribe(data) {
  axios.post('/api/subscribe', {
    data: data
  })
  .then(res => {
    console.log(res)
  })
  .catch(err => {console.log(err);});
}

export { postSurveyData };



// WEBPACK FOOTER //
// ./src/actions/Map/submitAction.js